export enum EVAL_CRITERION {
  CONCISENESS = "conciseness",
  RELEVANCY = "relevancy",
  HARMFULNESS = "harmfulness",
  DETAILIZATION = "detailization",
  CORRECTNESS = "correctness",
  FAITHFULNESS = "faithfulness",
}

export enum EVAL_CATEGORY {
  GREETING = "greeting",
  FACTUAL = "factual",
  RAG = "rag",
  SAFETY = "safety",
}

export enum EVAL_RUN_STATUS {
  RUNNING = "running",
  COMPLETED = "completed",
  FAILED = "failed",
}

export type EvalAverageScores = Partial<Record<EVAL_CRITERION, number>>;

export interface EvalScoreModel {
  criterion: EVAL_CRITERION;
  score: number;
  reasoning?: string;
}

export interface EvalResultModel {
  case_id: string;
  category: EVAL_CATEGORY;
  input_query: string;
  expected_answer: string | null;
  context: string | null;
  response: string;
  scores: EvalScoreModel[];
  latency_ms: number;
}

export interface EvalRunModel {
  id: number;
  uuid: string;
  status: EVAL_RUN_STATUS;
  total_cases: number;
  average_scores: EvalAverageScores;
  result_count: number;
  created_at: string;
}

export type EvalRunDetailModel = Omit<EvalRunModel, "result_count"> & {
  results: EvalResultModel[];
};

export interface EvalCategoryModel {
  name: EVAL_CATEGORY;
  description: string;
  requiredFields: string[];
  criteria: EVAL_CRITERION[];
}
